import { SpineMeshUtils } from "../mesh/SpineMeshUtils";
import { ChangeDeform } from "./change/ChangeDeform";
import { ChangeDrawOrder } from "./change/ChangeDrawOrder";
import { ChangeRGBA } from "./change/ChangeRGBA";
import { ChangeSlot } from "./change/ChangeSlot";
const step = 1 / 30;
export class AnimationRender {
    static getFloat32Array(bone) {
        let rs = new Float32Array(8);
        rs[0] = bone.a;
        rs[1] = bone.b;
        rs[2] = bone.worldX;
        rs[3] = 0;
        rs[4] = bone.c;
        rs[5] = bone.d;
        rs[6] = bone.worldY;
        rs[7] = 0;
        return rs;
    }
    constructor() {
        this.isDynamic = false;
        this.changeMap = new Map();
        this.frames = [];
        this.skinDataArray = [];
        this.boneFrames = [];
        this.eventsFrames = [];
    }
    getFrameIndex(time, frameIndex) {
        let frames = this.frames;
        let n = frames.length;
        for (let i = 1; i < n; i++)
            if (frames[i] > time)
                return i - 1;
        return n - 1;
    }
    cacheBones(preRender) {
        let duration = preRender._play(this.name);
        let totalFrame = Math.round(duration / step) || 1;
        for (let i = 0; i <= totalFrame; i++) {
            let bones = preRender._updateState(i == 0 ? 0 : step);
            let frame = [];
            this.boneFrames.push(frame);
            for (let j = 0; j < bones.length; j++) {
                let bone = bones[j];
                let rs = AnimationRender.getFloat32Array(bone);
                frame.push(rs);
            }
        }
    }
    check(animation, preRender) {
        this.name = animation.name;
        let timeline = animation.timelines;
        let changeMap = this.changeMap;
        let renderFrames = this.frames;
        let hasClip = false;
        renderFrames.push(0);
        changeMap.set(0, {});
        for (let i = 0, n = timeline.length; i < n; i++) {
            let time = timeline[i];
            let frames = time.frames;
            if (time instanceof spine.AttachmentTimeline) {
                let attachmentNames = time.attachmentNames;
                let slotIndex = time.slotIndex;
                for (let j = 0, m = frames.length; j < m; j++) {
                    let frame = frames[j];
                    let change = new ChangeSlot();
                    change.slotId = slotIndex;
                    change.attachment = attachmentNames[j] || null;
                    let changeItem = changeMap.get(frame);
                    if (!changeItem) {
                        this.frames.indexOf(frame) == -1 && this.frames.push(frame);
                        changeItem = {
                            iChanges: []
                        };
                        changeMap.set(frame, changeItem);
                    }
                    let arr = changeItem.iChanges = changeItem.iChanges || [];
                    arr.push(change);
                }
            }
            else if (time instanceof spine.DrawOrderTimeline) {
                let orders = time.drawOrders;
                for (let j = 0, m = frames.length; j < m; j++) {
                    let frame = frames[j];
                    let change = new ChangeDrawOrder();
                    change.order = orders[j];
                    let changeItem = changeMap.get(frame);
                    if (!changeItem) {
                        this.frames.indexOf(frame) == -1 && this.frames.push(frame);
                        changeItem = {
                            iChanges: []
                        };
                        changeMap.set(frame, changeItem);
                    }
                    let arr = changeItem.iChanges = changeItem.iChanges || [];
                    arr.push(change);
                }
            }
            else if (time instanceof (spine.ColorTimeline || spine.RGBATimeline) || (spine.TwoColorTimeline && time instanceof spine.TwoColorTimeline)) {
                let rgba = time;
                let slotIndex = rgba.slotIndex;
                if (frames.length == 5 && frames[0] == 0 && frames[4] == 0) {
                    let change = new ChangeSlot();
                    change.slotId = slotIndex;
                    change.attachment = null;
                    let frame = 0;
                    let changeItem = changeMap.get(frame);
                    if (!changeItem) {
                        this.frames.indexOf(frame) == -1 && this.frames.push(frame);
                        changeItem = {
                            iChanges: []
                        };
                        changeMap.set(frame, changeItem);
                    }
                    let arr = changeItem.iChanges = changeItem.iChanges || [];
                    arr.push(change);
                }
                else {
                    let changeRGBA = new ChangeRGBA(slotIndex);
                    let startFrame = frames[0];
                    let num = frames.length / 5 | 0;
                    let endFrame = frames[(num - 1) * 5];
                    changeRGBA.startFrame = startFrame;
                    changeRGBA.endFrame = endFrame;
                    let changeItem = changeMap.get(startFrame);
                    if (!changeItem) {
                        this.frames.indexOf(startFrame) == -1 && this.frames.push(startFrame);
                        changeItem = {
                            vChanges: []
                        };
                        changeMap.set(startFrame, changeItem);
                    }
                    this.frames.indexOf(endFrame) == -1 && this.frames.push(endFrame);
                    let arr = changeItem.vChanges = changeItem.vChanges || [];
                    arr.push(changeRGBA);
                }
            }
            else if (time instanceof window.spine.ClippingAttachment) {
                hasClip = true;
            }
            else if (time instanceof window.spine.EventTimeline) {
                if (preRender.canCache) {
                    let eventTime = time;
                    let events = eventTime.events;
                    for (let j = 0, m = frames.length; j < m; j++) {
                        let frame = frames[j];
                        let event = events[j];
                        let arr = this.eventsFrames[Math.round(frame / step)] = this.eventsFrames[frame] || [];
                        arr.push(event);
                    }
                }
            }
            else if (time instanceof spine.DeformTimeline) {
                let slotIndex = time.slotIndex;
                let change = new ChangeDeform();
                change.slotId = slotIndex;
                let startFrame = frames[0];
                let endFrame = frames[frames.length - 1];
                change.startFrame = startFrame;
                change.endFrame = endFrame;
                let changeItem = changeMap.get(startFrame);
                if (!changeItem) {
                    this.frames.indexOf(startFrame) == -1 && this.frames.push(startFrame);
                    changeItem = {
                        vChanges: []
                    };
                    changeMap.set(startFrame, changeItem);
                }
                this.frames.indexOf(endFrame) == -1 && this.frames.push(endFrame);
                let arr = changeItem.vChanges = changeItem.vChanges || [];
                arr.push(change);
            }
            else {
            }
        }
        this.isDynamic = !!changeMap.size;
        renderFrames.sort();
        if (!hasClip) {
            if (preRender.canCache) {
                this.cacheBones(preRender);
                this.isCache = true;
            }
        }
        this.frameNumber = renderFrames.length;
    }
    createSkinData(mainVB, mainIB, tempIbCreate, slotAttachMap, attachMap, type) {
        let skinData = new SkinAniRenderData();
        skinData.type = type;
        let frames = this.frames;
        skinData.init(this.changeMap, mainVB, mainIB, tempIbCreate, frames, slotAttachMap, attachMap, this.isDynamic);
        skinData.updateBoneMat = this.isCache ? (this.eventsFrames.length == 0 ? skinData.updateBoneMatCache : skinData.updateBoneMatCacheEvent) : skinData.updateBoneMatByBone;
        this.skinDataArray.push(skinData);
        return skinData;
    }
    destroy() {
        for (let i = 0, n = this.skinDataArray.length; i < n; i++)
            this.skinDataArray[i].destroy();
        this.skinDataArray.length = 0;
        this.frames.length = 0;
        this.changeMap.clear();
    }
}
export class SkinAniRenderData {
    constructor() {
        this.maxVertexCount = 0;
        this.maxIndexCount = 0;
        this.isDynamic = false;
        this.renderDatas = [];
    }
    getMesh() {
        return this._defaultMesh;
    }
    getFrameData(frameIndex) {
        return this.renderDatas[frameIndex] || this._defaultFrameData;
    }
    updateBoneMatCache(delta, animation, bones, state, boneMat, ofx = 0, ofy = 0) {
        this.vb.updateBoneCache(animation.boneFrames, delta / step, boneMat, ofx, ofy);
    }
    updateBoneMatCacheEvent(delta, animation, bones, state, boneMat) {
        let f = delta / step;
        this.vb.updateBoneCache(animation.boneFrames, f, boneMat);
        let currFrame = Math.round(f);
        let curentTrack = state.currentTrack;
        let lastEventFrame = curentTrack.lastEventFrame;
        if (lastEventFrame == currFrame) {
            return;
        }
        if (lastEventFrame > currFrame || lastEventFrame == undefined) {
            lastEventFrame = -1;
        }
        if (currFrame - lastEventFrame <= 1) {
            let events = animation.eventsFrames[currFrame];
            if (events) {
                for (let i = 0, n = events.length; i < n; i++) {
                    state.dispatchEvent(null, "event", events[i]);
                }
            }
        }
        else {
            for (let i = lastEventFrame + 1; i <= currFrame; i++) {
                let events = animation.eventsFrames[i];
                if (events) {
                    for (let j = 0, m = events.length; j < m; j++) {
                        state.dispatchEvent(null, "event", events[j]);
                    }
                }
            }
        }
        curentTrack.lastEventFrame = currFrame;
    }
    updateBoneMatByBone(delta, animation, bones, state, boneMat, ofx = 0, ofy = 0) {
        this.vb.updateBone(bones, boneMat, ofx, ofy);
    }
    init(changeMap, mainVB, ibCreator, tempCreator, frames, slotAttachMap, attachMap, isDynamic) {
        this.mainIB = ibCreator;
        this.isDynamic = isDynamic;
        this.canInstance = !this.isDynamic;
        if (isDynamic) {
            this.vb = mainVB.clone();
            this.vb.initBoneMat();
            let tAttachMap = attachMap.slice();
            let framesLength = frames.length;
            let order;
            for (let i = 0; i < framesLength; i++) {
                let frame = frames[i];
                let fcs = changeMap.get(frame);
                if (!fcs)
                    continue;
                let iChanges = fcs.iChanges;
                let data = {};
                if (iChanges) {
                    for (let j = 0, m = iChanges.length; j < m; j++) {
                        let ichange = iChanges[j];
                        if (!ichange.change(this.vb, slotAttachMap)) {
                            this.isNormalRender = true;
                        }
                        let newOrder = ichange.changeOrder(tAttachMap);
                        if (newOrder) {
                            order = newOrder;
                        }
                    }
                    tempCreator.createIB(tAttachMap, this.vb, order);
                    data.ib = tempCreator.ib.slice(0, tempCreator.ibLength);
                    data.mulitRenderData = tempCreator.outRenderData;
                    data.type = tempCreator.type;
                    data.size = tempCreator.size;
                }
                let vChanges = fcs.vChanges;
                if (vChanges) {
                    let myChangeVB = [];
                    for (let j = 0, m = vChanges.length; j < m; j++) {
                        let changeVBItem = vChanges[j].clone();
                        if (changeVBItem.initChange(this.vb)) {
                            changeVBItem.startFrame = i;
                            changeVBItem.endFrame = frames.indexOf(changeVBItem.endFrame);
                            myChangeVB.push(changeVBItem);
                        }
                    }
                    data.vChanges = myChangeVB;
                }
                this.renderDatas.push(data);
                if (!frame) {
                    if (!data.ib) {
                        data.mulitRenderData = ibCreator.outRenderData;
                        data.ib = ibCreator.ib.slice(0, this.mainIB.ibLength);
                        data.type = ibCreator.type;
                        data.size = ibCreator.size;
                    }
                    this._defaultFrameData = data;
                }
            }
            this.maxIndexCount = Math.max(tempCreator.maxIndexCount, this.mainIB.maxIndexCount);
        }
        else {
            this.vb = mainVB;
            this._defaultMesh = SpineMeshUtils.createMesh(this.type, this.vb, ibCreator, this.isDynamic);
            ;
            this.maxIndexCount = ibCreator.maxIndexCount;
        }
        this.maxVertexCount = this.vb.maxVertexCount;
        if (!this._defaultFrameData) {
            this._defaultFrameData = {
                mulitRenderData: ibCreator.outRenderData,
                ib: ibCreator.ib.slice(0, this.mainIB.ibLength),
                type: ibCreator.type,
                size: ibCreator.size
            };
        }
    }
    destroy() {
        this._defaultMesh && this._defaultMesh.destroy();
        this._defaultMesh = null;
        this._defaultFrameData = null;
        this.renderDatas = null;
    }
}
